import { render, staticRenderFns } from "./modalConfirm.vue?vue&type=template&id=5e5188b4&scoped=true"
import script from "./modalConfirm.vue?vue&type=script&lang=js"
export * from "./modalConfirm.vue?vue&type=script&lang=js"
import style0 from "./modalConfirm.vue?vue&type=style&index=0&id=5e5188b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5188b4",
  null
  
)

export default component.exports